"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Heading = exports.Divider = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var defaultHeadingStyles = (0, _styledComponents.css)(["align-items:center;color:inherit;font-weight:700;letter-spacing:0;", ";margin:", " 0;&:focus{outline:none;}"], _stylers["default"].lineHeight(-1), _stylers["default"].spacer(2));
var heading = {
  HEADING_LEVEL_1: (0, _styledComponents.css)(["", " ", " font-weight:400;"], _stylers["default"].fontSize(7), _stylers["default"].lineHeight(-2)),
  HEADING_LEVEL_2: (0, _styledComponents.css)(["", " ", ""], _stylers["default"].fontSize(5), _stylers["default"].lineHeight(-2)),
  HEADING_LEVEL_3: (0, _styledComponents.css)(["", ""], _stylers["default"].fontSize(3)),
  HEADING_LEVEL_4: (0, _styledComponents.css)(["", ""], _stylers["default"].fontSize(1)),
  HEADING_LEVEL_5: (0, _styledComponents.css)(["", " margin:", " 0;"], _stylers["default"].fontSize(), _tokens["default"].space),
  HEADING_LEVEL_6: (0, _styledComponents.css)(["", " margin:", " 0;"], _stylers["default"].fontSize(-1), _tokens["default"].space)
};

var underline = function underline(level) {
  var result = "border-bottom: 1px solid ".concat(_tokens["default"].border.color, ";");

  if (level === 1) {
    result += "padding-bottom: ".concat(_tokens["default"].space, ";");
  } else if (level > 1 && level < 5) {
    result += "padding-bottom: ".concat(_tokens["default"].spaceSm, ";");
  } else {
    result += "padding-bottom: 2px;";
  }

  return result;
};

var Divider = _styledComponents["default"].span.withConfig({
  displayName: "Headingstyles__Divider",
  componentId: "sc-1l2r6np-0"
})(["border-bottom:2px solid ", ";flex-grow:1;margin-left:", ";"], _tokens["default"].color.blackLighten70, _tokens["default"].space);

exports.Divider = Divider;

var Heading = _styledComponents["default"].div.withConfig({
  displayName: "Headingstyles__Heading",
  componentId: "sc-1l2r6np-1"
})(function (_ref) {
  var safeDisplayLevel = _ref.safeDisplayLevel,
      safeLevel = _ref.safeLevel,
      isHidden = _ref.isHidden,
      hasUnderline = _ref.hasUnderline,
      hasDivider = _ref.hasDivider,
      isLight = _ref.isLight;
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", " ", ""], defaultHeadingStyles, heading["HEADING_LEVEL_".concat(safeDisplayLevel || safeLevel)], isHidden ? _stylers["default"].visuallyHidden : "", hasUnderline ? underline(safeDisplayLevel || safeLevel) : "", hasDivider ? "display: flex;" : "", isLight ? "font-weight: 400;" : "");
});

exports.Heading = Heading;
//# sourceMappingURL=Heading.styles.js.map